
const state = {
    leaveRequests: [],
    leaveRequest: {id: null}
}

export default state
